// Add your custom JS here.

jQuery(document).ready(function($) {
    $(".email-encode").each(function () {
        $(this).html(atob($(this).data("contact")));
    })
    $(".fa-magnifying-glass").on("click", function () {
        $(this).closest("form").submit();
    })

    function trigger_match(){
        let heights = {};
        $(".matched_heights").each(function(){
            let group = $(this).data("match-group");
            let cont = $(this);
            heights = check_match_section(cont, 1, heights, group)
            heights = check_match_section(cont, 2, heights, group)
            heights = check_match_section(cont, 3, heights, group)
            heights = check_match_section(cont, 4, heights, group)
        })
        for(let g in heights){
            let sections = heights[g];
            for(let s in sections) {
                let h = sections[s];
                if(h != -999){
                    $(`.${g} .section${s}`).css('height', `${h}px`);
                }
            }
        }
    }
    function check_match_section(cont, section, heights, group){
        if(heights[group] == undefined) heights[group] = {};
        if(heights[group][section] == undefined) heights[group][section] = -999;
        cont.find(".section"+section).each(function(){
            let h = $(this).height();
            if(h > heights[group][section]) heights[group][section] = h;
        })
        return heights;
    }
    trigger_match();
});